import { clientEnv } from "../env";

interface WatchGrantReply {
  code: string;
  expiresAt: number;
}

export async function createWatchSessionGrant(sessionToken: string, organizationId?: string): Promise<WatchGrantReply> {
  const response = await fetch(`${clientEnv.apiBaseUrl}/watch/session/grant`, {
    method: "POST",
    headers: { "Content-Type": "application/json", Authorization: `Bearer ${sessionToken}` },
    body: JSON.stringify({ organizationId })
  });
  const payload = await response.json().catch(() => ({})) as Partial<WatchGrantReply> & { error?: string };
  if (!response.ok || typeof payload.code !== "string" || typeof payload.expiresAt !== "number") {
    throw new Error(payload.error ?? "No se pudo preparar la conexión con el Apple Watch.");
  }
  return payload as WatchGrantReply;
}

export function openWatchCompanion(code: string): void {
  if (!/^[A-Za-z0-9_-]{43}$/.test(code)) throw new Error("El código de conexión no es válido.");
  window.location.assign(`omnisynia://auth/watch?code=${encodeURIComponent(code)}`);
}
